module.exports = __webpack_public_path__ + "img/polkadot-js.36994126.svg";